"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAmountPropertySelector = createAmountPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const amount_format_selector_1 = require("./amount-format-selector");
const amount_input_box_1 = require("./amount-input-box");
const defaultAmountPropertySelectorWrapper = (props) => react_1.default.createElement("span", Object.assign({}, props));
const defaultAmountFormatSelector = (0, amount_format_selector_1.createAmountFormatSelector)({});
const defaultAmountInputBox = (0, amount_input_box_1.createAmountInputBox)({});
function createAmountPropertySelector({ AmountPropertySelectorWrapper = defaultAmountPropertySelectorWrapper, AmountFormatSelector = defaultAmountFormatSelector, AmountInputBox = defaultAmountInputBox }) {
    // eslint-disable-next-line functional/no-class
    return class AmountPropertySelector extends react_1.default.Component {
        render() {
            const { onValueChange, onFormatChanged, onFormatCleared, onFormatSelectorToggled, notNumericMessage, isRequiredMessage, validationFilter, propertyValueSet, propertyName, filterPrettyPrint, inputUnit, inputDecimalCount, readOnly, debounceTime = 350, unitsFormat, units, comparer = property_1.PropertyValue.defaultComparer
            // eslint-disable-next-line functional/no-this-expression
             } = this.props;
            const value = property_1.PropertyValueSet.getAmount(propertyName, propertyValueSet);
            return (react_1.default.createElement(AmountPropertySelectorWrapper, null,
                react_1.default.createElement(AmountInputBox, { value: value, inputUnit: inputUnit, inputDecimalCount: inputDecimalCount, notNumericMessage: notNumericMessage, isRequiredMessage: isRequiredMessage, errorMessage: _getValidationMessage(propertyValueSet, value, validationFilter, filterPrettyPrint, comparer), readOnly: readOnly, onValueChange: newAmount => onValueChange(newAmount !== undefined
                        ? property_1.PropertyValue.create("amount", newAmount)
                        : undefined), debounceTime: debounceTime }),
                react_1.default.createElement(AmountFormatSelector, { selectedUnit: inputUnit, selectedDecimalCount: inputDecimalCount, onFormatChanged: onFormatChanged, onFormatCleared: onFormatCleared, onFormatSelectorActiveChanged: onFormatSelectorToggled, unitsFormat: unitsFormat, units: units })));
        }
    };
}
function _getValidationMessage(propertyValueSet, value, validationFilter, filterPrettyPrint, comparer) {
    if (!value || !validationFilter) {
        return "";
    }
    if (property_1.PropertyFilter.isValid(propertyValueSet, validationFilter, comparer)) {
        return "";
    }
    else {
        return filterPrettyPrint(validationFilter);
    }
}
//# sourceMappingURL=amount-property-selector.js.map